module.exports = __webpack_public_path__ + "b74ddc1dc68b4e79075481d6da18aa8f.png";